// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__lPzg2","link":"HeaderSimple_link__Y-Mnz","linkSmall":"HeaderSimple_linkSmall__M4fwZ","inputSearch":"HeaderSimple_inputSearch__D133l"};